export namespace Environment {
  export const backEndUrl =
    process.env.REACT_APP_BACKEND_URL || "http://localhost:8080";
  export const stripePublishableKey =
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
}
